import refreshWidgets from 'common/src/modules/campaigns/store/insightsTab/actions/refreshWidgets';
import dashboardsApi from 'common/src/modules/dashboards/dashboards.api';
import {
  AiDashboardWidgetType,
  DashboardWidgetType,
} from 'common/src/modules/dashboards/dashboards.types';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {CLStore} from 'common/src/redux/store';
import getMatchingEnumValue from 'common/src/utils/typescriptUtils/getMatchingEnumValue';
import _find from 'lodash/find';
import {z} from 'zod';
import {CampaignAnalyticsToolName} from '../campaignAnalyticsAgent.enums';

const inputSchema = z.object({
  widgetId: z.number().describe('ID of widget to edit'),
  dashboardId: z.number().describe('ID of dashboard to edit'),
  name: z.string().describe('New widget name').nullable().optional(),
  type: z.nativeEnum(AiDashboardWidgetType).describe('New widget type').nullable().optional(),
});

function updateWidgetTool(store: CLStore) {
  async function execute({
    input: {widgetId, dashboardId, name, type},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const widgets = await dashboardsApi.getWidgets(dashboardId);

    const widget = _find(widgets, {id: widgetId});

    if (!widget) {
      return toolError('Widget not found');
    }

    try {
      await dashboardsApi.editWidget({
        ...widget,
        name: name ?? widget.name,
        type:
          getMatchingEnumValue(
            AiDashboardWidgetType,
            DashboardWidgetType,
            type as AiDashboardWidgetType,
          ) ?? widget.type,
      });

      store.dispatch(refreshWidgets({dashboardId}));

      return toolResult('Widget edited successfully');
    } catch (error) {
      return toolError('An error occurred while updating the widget');
    }
  }

  return tool({
    name: CampaignAnalyticsToolName.UpdateWidget,
    displayName: 'Updating Widget',
    description: 'Rename or change type of an existing dashboard widget',
    execute,
    inputSchema,
  });
}

export default updateWidgetTool;
